import { env } from 'env';

const oktaConfig = {
  oidc: {
    clientId: env.REACT_APP_OKTA_CLIENT_ID || '',
    issuer: env.REACT_APP_OKTA_ISSUER || '',
    redirectUri: env.REACT_APP_OKTA_REDIRECT_URI || '',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  },
};

export default oktaConfig;
